// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nb-product-list {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 20px;
    font-size: 20px;
} 

.nb-product-list-container {
    margin-left: 0px;
    margin-top: 10px;
    width: 200px;
    height: 220px;
    border-radius: 20px;
    padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Navbar/ProductDropDown.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".nb-product-list {\n    width: 20px;\n    height: 20px;\n    margin-right: 10px;\n    margin-left: 10px;\n    margin-bottom: 20px;\n    font-size: 20px;\n} \n\n.nb-product-list-container {\n    margin-left: 0px;\n    margin-top: 10px;\n    width: 200px;\n    height: 220px;\n    border-radius: 20px;\n    padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
